import {requestGet, requestPost} from "../util/request";
import {LoginProps} from "../types/authority";
import {detailProps, prefabricatedChatProps, stylesCategoryProps, stylesListProps} from "../types/selectStyles";

interface categoryResponse {
    code: number;
    data: stylesCategoryProps[];
    message: string;
    i18nKey?: string
}

interface listResponse {
    code: number;
    data: stylesListProps[];
    message: string;
    i18nKey?: string
}

interface detailResponse {
    code: number;
    data: detailProps;
    message: string;
    i18nKey?: string
}

interface suggestionsResponse {
    code: number;
    data: prefabricatedChatProps;
    message: string;
    i18nKey?: string
}

export const getCategory = async (): Promise<stylesCategoryProps[] | null> => {
    try {
        const response = await requestGet(
            `/api/mood/aiStrategy/listAllType`
        ) as categoryResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const getStyleList = async (typeCode: string): Promise<stylesListProps[] | null> => {
    try {
        const response = await requestGet(
            `/api/mood/aiStrategy/list?typeCode=${typeCode}`
        ) as listResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const getStyleDetail = async (strategyCode: string): Promise<detailProps | null> => {
    try {
        const response = await requestGet(
            `/api/mood/aiStrategy/detail?code=${strategyCode}`
        ) as detailResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

export const getSuggestions = async (conversionId: string): Promise<prefabricatedChatProps | null> => {
    try {
        const response = await requestGet(
            `/api/mood/suggestions?conversionId=${conversionId}`
        ) as suggestionsResponse;

        const { code, data, message } = response;

        if (code === 200) {
            return data;
        }

        return null;
    } catch (error) {
        throw error instanceof Error ? error : new Error('network error');
    }
}

